import EventEmitter from 'eventemitter3'

export const obsEvent = new EventEmitter()

export function onMenuChanged() {
    obsEvent.emit('MENU-CHANGED')
}

export function removeOnMenuChanged() {
    obsEvent.removeListener('MENU-CHANGED')
}
